module.exports = __webpack_public_path__ + "static/img/tie.4770e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/tie.png
// module id = cKhx
// module chunks = 0